import { useEffect, useState } from 'react';

const defaultOption = {
  root: null,
  rootMargin: '20px',
  threshold: 0,
};

export default function useInfinityScroll(
  loadRef: React.RefObject<HTMLDivElement>,
  onLoadMore: (entry: IntersectionObserverEntry[]) => void,
  option = defaultOption,
) {
  const [observer, setObserver] = useState<any>();

  useEffect(() => {
    if (loadRef.current) {
      setObserver(new IntersectionObserver(onLoadMore, option));
    }
  }, [loadRef.current]);

  useEffect(() => {
    observer && observer.observe(loadRef.current);
    return () => observer && observer.disconnect();
  }, [loadRef.current, observer]);
}
